import { Button } from "@babackapp/ui/components/button";
import {
  useEmailThemeRadius,
  useThemeContextualColors,
  sectionToParent,
} from "../../hooks";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { getThemeButtonStyle } from "../button/shared-button-styling";
import { DoubleButtonsBlockProps } from "./types";
import { cn } from "@babackapp/ui/lib/utils";

export default function DoubleButtonsWeb({
  block,
  formatter,
  theme,
  locale,
  defaultLocale,
  section,
  shop,
  isEditor,
}: DoubleButtonsBlockProps & { isEditor?: boolean }) {
  const alignment = block.alignment || "center";
  const buttonRadius = useEmailThemeRadius(theme, "button");
  const colors = useThemeContextualColors(theme, sectionToParent(section));

  const button0Content =
    block.content?.[locale]?.button0 || block.content?.[defaultLocale]?.button0;
  const button1Content =
    block.content?.[locale]?.button1 || block.content?.[defaultLocale]?.button1;

  const button0Style = getThemeButtonStyle({
    variant: block.properties?.button0Variant || "default",
    theme,
    textColor: colors.text,
  });

  const button1Style = getThemeButtonStyle({
    variant: block.properties?.button1Variant || "outline",
    theme,
    textColor: colors.text,
  });

  let formattedButton0Text =
    !!formatter && button0Content?.text
      ? formatter(button0Content?.text)
      : button0Content?.text;
  let formattedButton1Text =
    !!formatter && button1Content?.text
      ? formatter(button1Content?.text)
      : button1Content?.text;
  const formattedButton0Href =
    !!formatter && button0Content?.href
      ? formatter(button0Content?.href)
      : button0Content?.href;
  const formattedButton1Href =
    !!formatter && button1Content?.href
      ? formatter(button1Content?.href)
      : button1Content?.href;

  if (!formattedButton0Text?.length) {
    if (isEditor) {
      formattedButton0Text = "Ajoutez un label";
    } else {
      return null; // Don't render anything if there's no content and we're not in the editor
    }
  }

  if (!formattedButton1Text?.length) {
    if (isEditor) {
      formattedButton1Text = "Ajoutez un label";
    } else {
      return null; // Don't render anything if there's no content and we're not in the editor
    }
  }

  return (
    <EmailComponentWrapper shop={shop}>
      <div
        className={cn("flex gap-4", {
          "justify-center": alignment === "center",
          "justify-start": alignment === "left",
          "justify-end": alignment === "right",
        })}
      >
        <a href={formattedButton0Href}>
          <Button style={button0Style} className={buttonRadius}>
            {formattedButton0Text}
          </Button>
        </a>
        <a href={formattedButton1Href}>
          <Button style={button1Style} className={buttonRadius}>
            {formattedButton1Text}
          </Button>
        </a>
      </div>
    </EmailComponentWrapper>
  );
}
